module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_pp13_3016.8b33b0c0.png";